export const TopChangesFilterOption = {
  AllChanges: 'AllChanges',
  TopDecliners: 'TopDecliners',
  TopGainers: 'TopGainers',
  Insights: 'Insights',
};

export const TopChangesFilterSortOptionMap = {
  [TopChangesFilterOption.AllChanges]: 'Absolute',
  [TopChangesFilterOption.TopGainers]: 'Gain',
  [TopChangesFilterOption.TopDecliners]: 'Decline',
  [TopChangesFilterOption.Insights]: 'Insight',
};

export const AccountsMode = {
  Smart: 0,
  Expert: 1,
};

export const ConversionFilterOption = {
  AllChanges: 'AllChanges',
  TopDecliners: 'TopDecliners',
  TopGainers: 'TopGainers',
};

export const ConversionFilterSortOptionMap = {
  AllChanges: 'Absolute',
  TopGainers: 'Gain',
  TopDecliners: 'Decline',
};
